export default __webpack_public_path__ + "media/images/services/service-01-370x250-653242b9aa1b82ee9b8ca784789d1a87.jpg";